import { DefaultForm, DefaultFormCsi } from "./types";

export const DEFAULT_FORM: DefaultForm = {
  score: undefined,
  comment: "",
};

export const DEFAULT_FORM_CSI: DefaultFormCsi = {
  score: [{ id: "0", importance: undefined, satisfaction: undefined }],
  comment: "",
};

export const SUCCESSFUL_SUBMIT_TEXT = "Спасибо за ваш отзыв";
